import ContainerRoutes from "../quality_reports/container";
import ProcessRoutes from "../quality_reports/process";

export default [...ContainerRoutes, ...ProcessRoutes];
